export default __webpack_public_path__ + "static/media/Scenes_03.15c4f7d5.png";